import $ from 'jquery'

function multipleSelect($element) {

  /* PRIVATE VARIABLES */

  var $mainContainer = $element,
      $selectBox,
      $choicesList,
      $arrowDiv,
      $chosenListSecondary,
      $wrapper,
      $borderChosenList,
      lockSubject,
      $subjectsWrapper;

  /* PRIVATE METHODS */

  // constructor
  function init() {
    $selectBox = $("select.multiple_subject_select", $mainContainer);
    lockSubject = $selectBox.data('lockSubject');

    initialSetup();
    bindDomEvents();
  }

  /* Duplicates contents in select box and text field and converts to an unordered list.
   * Hides the items in the list that are not selected.
   */
  function initialSetup() {
    // create choices list
    $choicesList = $(document.createElement("ul"));
    $choicesList.attr( {'id': 'choicesList', 'class': 'subjectList'} );

    // Create Secondary Subjects
    $chosenListSecondary = $(document.createElement("ul"));
    $chosenListSecondary.attr({'id': 'chosenListSecondary', 'class': 'subjectList'});

    $('option', $selectBox).each(function() {
      var $this = $(this),
          subjectId = $this.val(),
          subjectName = $this.html(),
          $li = $('<li data-value="' + subjectId + '"><a href="#">' + subjectName + '</a></li>');

      if ($this.is(':selected')) {
        $li.addClass('selected');
      }

      if (lockSubject && lockSubject == subjectId) {
        $li.addClass('locked');
        $chosenListSecondary.prepend($li.clone());
      } else {
        $choicesList.append($li);
        $chosenListSecondary.append($li.clone());
      }
    });

    $borderChosenList = $('<div>').attr({'class': 'borderChosenList'});

    // append to DOM
    $wrapper = $(document.createElement("div"));

    // Choises List
    $wrapper.append($choicesList);

    // Arrow
    $arrowDiv =  $(document.createElement("div"));
    $arrowDiv.attr( {'id': 'arrowWrapper'} );
    $wrapper.append($arrowDiv);

    // Subjects Wrapper
    $subjectsWrapper = $(document.createElement("div"));
    $subjectsWrapper.attr( {'id': 'subjectsWrapper'} );

    // Secondary Subjects
    $subjectsWrapper.append($borderChosenList.append($chosenListSecondary));

    $wrapper.append($subjectsWrapper);

    $selectBox.replaceWith($wrapper);
  }

  function bindDomEvents() {
    $choicesList.on("click", "li", function() {
      addToChosenList(this);
    });

    $chosenListSecondary.on("click", "li", function() {
      removeFromChosenListSecondary(this);
    });

    $('a', $choicesList).on('click', function(e) {
      e.preventDefault();
    });

    $('a', $chosenListSecondary).on('click', function(e) {
      e.preventDefault();
    });
  }

  function addToChosenList(element) {
    $("li", $choicesList).each( function() {
      if ($(this).attr('data-value') == $(element).attr('data-value')) {
        var dataValue = $(this).attr('data-value');
        $(this).addClass('selected');

        $("li", $chosenListSecondary).each( function() {
          if ($(this).attr('data-value') == dataValue) {
            $(this).addClass('selected');
          }
        });
      }
    });
  }

  function removeFromChosenListSecondary(element) {
    if ($(element).hasClass('locked')) return;
    $("#choicesList li, #chosenListSecondary li").filter(function() {
      if ($(this).attr('data-value') == $(element).attr('data-value')) {
        $(this).removeClass("selected");
      }
    });
  }

  // run constructor
  init();

  /* PUBLIC METHODS */

  return {
    updateSelectedSubjects: function() {
      $("input[type='hidden']", $wrapper).remove();
      var secondaryPresent = false;
      // Secondary Subjects
      $('li.selected', $choicesList).each(function() {
        var value = $(this).attr("data-value"),
            $chosenSubjectsField = $(document.createElement("input"));
          $chosenSubjectsField.attr({"type": "hidden", "name": $selectBox.attr("name")}).val(value);
          $wrapper.append($chosenSubjectsField);
          secondaryPresent = true;
      });

      if (!secondaryPresent) {
        var $chosenSubjectsField = $(document.createElement("input"));
        $chosenSubjectsField.attr({"type": "hidden", "name": $selectBox.attr("name")}).val("")
        $wrapper.append($chosenSubjectsField);
      }
    }
  };

}

// jQuery plugin method
$.fn.multipleSelect = function() {
  return this.each(function() {
    var $this = $(this);

    // Store plugin object in this element's data if it doesn't already exist
    if (!$this.data('multipleSelect')) {
      $this.data('multipleSelect', multipleSelect($this));
    }
  });
};
